export const categoryOptions = {
  PIL: {
    id: 'PIL',
    options: [
      {
        id: '1',
      },
      {
        id: '2',
      },
      {
        id: '3',
      },
      {
        id: '4',
      },
    ],
  },
  COP: {
    geoLevelId: 'OPR',
    id: 'COP',
    options: [
      {
        id: 'AFG ABC',
      },
      {
        id: 'AGO ABC',
      },
      {
        id: 'ALB ABC',
      },
      {
        id: 'AMERB ABC',
      },
      {
        id: 'ARG RO ABC',
      },
      {
        id: 'ARM ABC',
      },
      {
        id: 'ASORB ABC',
      },
      {
        id: 'AUS MC ABC',
      },
      {
        id: 'AZE ABC',
      },
      {
        id: 'BDI ABC',
      },
      {
        id: 'BEL MC ABC',
      },
      {
        id: 'BFA ABC',
      },
      {
        id: 'BGD ABC',
      },
      {
        id: 'BGR ABC',
      },
      {
        id: 'BIH ABC',
      },
      {
        id: 'BLR ABC',
      },
      {
        id: 'BRA ABC',
      },
      {
        id: 'CAF ABC',
      },
      {
        id: 'CAN ABC',
      },
      {
        id: 'CHN ABC',
      },
      {
        id: 'CHN RO ABC',
      },
      {
        id: 'CIV ABC',
      },
      {
        id: 'CIV MC ABC',
      },
      {
        id: 'CMR ABC',
      },
      {
        id: 'COD ABC',
      },
      {
        id: 'COD RO ABC',
      },
      {
        id: 'COG ABC',
      },
      {
        id: 'COL ABC',
      },
      {
        id: 'COTS',
      },
      {
        id: 'CRI ABC',
      },
      {
        id: 'CYP ABC',
      },
      {
        id: 'DEU ABC',
      },
      {
        id: 'DJI ABC',
      },
      {
        id: 'DZA ABC',
      },
      {
        id: 'ECU ABC',
      },
      {
        id: 'EGY ABC',
      },
      {
        id: 'EHGLRB ABC',
      },
      {
        id: 'ERI ABC',
      },
      {
        id: 'ESH ABC',
      },
      {
        id: 'ESP ABC',
      },
      {
        id: 'ETH ABC',
      },
      {
        id: 'EURRB ABC',
      },
      {
        id: 'FRA ABC',
      },
      {
        id: 'GBR ABC',
      },
      {
        id: 'GEO ABC',
      },
      {
        id: 'GHA ABC',
      },
      {
        id: 'GRC ABC',
      },
      {
        id: 'GTM ABC',
      },
      {
        id: 'HND ABC',
      },
      {
        id: 'HRV ABC',
      },
      {
        id: 'HUN MC ABC',
      },
      {
        id: 'IDN ABC',
      },
      {
        id: 'IND ABC',
      },
      {
        id: 'IRN ABC',
      },
      {
        id: 'IRQ ABC',
      },
      {
        id: 'ISR ABC',
      },
      {
        id: 'ITA MC ABC',
      },
      {
        id: 'JOR ABC',
      },
      {
        id: 'JPN ABC',
      },
      {
        id: 'KAZ RO ABC',
      },
      {
        id: 'KEN ABC',
      },
      {
        id: 'KOR ABC',
      },
      {
        id: 'KOS ABC',
      },
      {
        id: 'LBN ABC',
      },
      {
        id: 'LBR ABC',
      },
      {
        id: 'LBY ABC',
      },
      {
        id: 'LKA ABC',
      },
      {
        id: 'MAR ABC',
      },
      {
        id: 'MDA ABC',
      },
      {
        id: 'MENARB ABC',
      },
      {
        id: 'MEX ABC',
      },
      {
        id: 'MKD ABC',
      },
      {
        id: 'MLI ABC',
      },
      {
        id: 'MLT ABC',
      },
      {
        id: 'MMR ABC',
      },
      {
        id: 'MNE ABC',
      },
      {
        id: 'MOZ ABC',
      },
      {
        id: 'MRT ABC',
      },
      {
        id: 'MWI ABC',
      },
      {
        id: 'MYS ABC',
      },
      {
        id: 'NER ABC',
      },
      {
        id: 'NGA ABC',
      },
      {
        id: 'NPL ABC',
      },
      {
        id: 'OOA ABC',
      },
      {
        id: 'OOE ABC',
      },
      {
        id: 'OOM ABC',
      },
      {
        id: 'OOR ABC',
      },
      {
        id: 'PAK ABC',
      },
      {
        id: 'PAN RO ABC',
      },
      {
        id: 'PER ABC',
      },
      {
        id: 'PHL ABC',
      },
      {
        id: 'POL ABC',
      },
      {
        id: 'ROU ABC',
      },
      {
        id: 'RUS ABC',
      },
      {
        id: 'RWA ABC',
      },
      {
        id: 'SAORB ABC',
      },
      {
        id: 'SAU MC ABC',
      },
      {
        id: 'SDN ABC',
      },
      {
        id: 'SEN RO ABC',
      },
      {
        id: 'SLV ABC',
      },
      {
        id: 'SOM ABC',
      },
      {
        id: 'SRB ABC',
      },
      {
        id: 'SSD ABC',
      },
      {
        id: 'SWE MC ABC',
      },
      {
        id: 'SYR ABC',
      },
      {
        id: 'TCD ABC',
      },
      {
        id: 'THA ABC',
      },
      {
        id: 'TJK ABC',
      },
      {
        id: 'TUN ABC',
      },
      {
        id: 'TUR ABC',
      },
      {
        id: 'TZA ABC',
      },
      {
        id: 'UGA ABC',
      },
      {
        id: 'UKR ABC',
      },
      {
        id: 'USA RO ABC',
      },
      {
        id: 'VEN ABC',
      },
      {
        id: 'WCARB ABC',
      },
      {
        id: 'XAM ABC',
      },
      {
        id: 'XAS ABC',
      },
      {
        id: 'XEHGL ABC',
      },
      {
        id: 'XEU ABC',
      },
      {
        id: 'XME ABC',
      },
      {
        id: 'XSAO ABC',
      },
      {
        id: 'XWCA ABC',
      },
      {
        id: 'YEM ABC',
      },
      {
        id: 'ZAF RO ABC',
      },
      {
        id: 'ZMB ABC',
      },
      {
        id: 'ZWE ABC',
      },
    ],
  },
  ALL: {
    id: 'ALL',
    options: null,
  },
  COA: {
    id: 'COA',
    options: [
      {
        id: 'A',
      },
      {
        id: 'B',
      },
      {
        id: 'C',
      },
      {
        id: 'D',
      },
      {
        id: 'E',
      },
      {
        id: 'F',
      },
      {
        id: 'G',
      },
      {
        id: 'H',
      },
      {
        id: 'I',
      },
      {
        id: 'J',
      },
      {
        id: 'K',
      },
      {
        id: 'L',
      },
      {
        id: 'M',
      },
      {
        id: 'N',
      },
      {
        id: 'O',
      },
      {
        id: 'P',
      },
      {
        id: 'U',
      },
      {
        id: 'V',
      },
      {
        id: 'W',
      },
      {
        id: 'X',
      },
      {
        id: 'Y',
      },
    ],
  },
  CIA: {
    id: 'CIA',
    options: [
      {
        id: '6',
      },
      {
        id: '7',
      },
      {
        id: '8',
      },
      {
        id: '9',
      },
    ],
  },
};

export const categoryOptionsWithEarmarking = {
  ALL: {
    id: 'ALL',
    options: null,
  },
  EMK: {
    id: 'EMK',
    options: [
      {
        id: 'Softly earmarked',
      },
      {
        id: 'Unearmarked',
      },
      {
        id: 'Earmarked',
      },
      {
        id: 'Tightly earmarked',
      },
    ],
  },
  CTY: {
    id: 'CTY',
    options: [
      {
        id: 'Junior Professional Officer',
      },
      {
        id: 'In-Kind',
      },
      {
        id: 'Cash',
      },
      {
        id: 'UN Regular Budget',
      },
    ],
  },
};
